<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">

                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Selecione uma conta
                </h2>
            </div>
        </template>
        <div class="pb-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 pt-10">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4">
                    <flash :timeout="5000"/>
                    <div>
                        <inertia-table
                            :data="accounts"
                            :params="params"
                            :columns="columns"
                            :enablePageSize="false"
                            :enable-display="true"
                            :filters="filters"
                            empty-message="Nenhuma conta corrente vinculada ao seu usuário. Por favor entre em contato com o atendimento"
                            id="id"
                            routeName="select.index"
                            @item-selected="show">
                            <template slot-scope="row" slot="customer.name">
                                {{ row.item.customer.name }}
                            </template>
                            <template slot-scope="row" slot="account">
                                <div class="text-center">{{ row.item.number }}-{{ row.item.digit }}</div>
                            </template>
                            <template slot-scope="row" slot="balance.value">
                                <div class="text-right" v-if="row.item.balance">{{ row.item.balance.value | currency }}</div>
                            </template>
                            <template slot-scope="row" slot="balance.updated">
                                <div class="text-center" v-if="row.item.balance">{{ row.item.balance.updated | smallDateTime }}</div>
                            </template>

                        </inertia-table>
                    </div>
                </div>
            </div>
        </div>


    </app-layout>
</template>
<script>
import AppLayout from './../../Layouts/AppLayout';
import InertiaTable from "../../Helpers/Tables/InertiaTable";
import Flash from "../../Helpers/Flash";

export default {
    components: {
        AppLayout,
        Flash,
        InertiaTable,
    },
    props: ['accounts', 'errors'],
    data() {
        return {
            columns: [
                {text: 'Cliente', className: 'text-left', key: 'customer.name', sortable: true},
                {text: 'Conta', className: 'text-center', key: 'account', sortable: true},
                {text: 'Apelido', className: 'text-left', key: 'name', sortable: true},
                {text: 'Saldo', className: 'text-right', key: 'balance.value', sortable: true},
                {text: 'Dt.Saldo', className: 'text-center', key: 'balance.updated', sortable: true},
            ],
            params: {
                sort: 'customer.name:asc',
                page: 1,
                ...this.$page.props.queryString
            },
            filters: [],
            form: {
                account: null,
            }
        }
    },
    methods: {
        show: function (item) {
            this.$inertia.get(this.route('select.show', item.id), {customer_id: item.customer.id});
        }
    }
}
</script>
